import { render, staticRenderFns } from "./TaskItemsTable.vue?vue&type=template&id=181e071c&scoped=true"
import script from "./TaskItemsTable.vue?vue&type=script&lang=ts"
export * from "./TaskItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./TaskItemsTable.vue?vue&type=style&index=0&id=181e071c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e071c",
  null
  
)

export default component.exports